import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconNotificationPaused = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 19.876 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M19.630,19.263 C19.343,19.731 18.827,20.000 18.214,20.000 L13.891,20.000 C13.891,22.205 12.108,24.000 9.916,24.000 C7.726,24.000 5.943,22.205 5.943,20.000 L1.622,20.000 C1.010,20.000 0.494,19.731 0.207,19.263 C-0.081,18.795 -0.089,18.209 0.185,17.658 L2.965,12.735 L2.965,7.000 C2.965,3.140 6.084,0.000 9.916,0.000 C13.751,0.000 16.870,3.140 16.870,7.000 L16.870,12.735 L19.626,17.611 C19.925,18.209 19.917,18.794 19.630,19.263 ZM9.916,22.000 C11.012,22.000 11.904,21.103 11.904,20.000 L7.930,20.000 C7.930,21.103 8.821,22.000 9.916,22.000 ZM15.014,13.494 C15.004,13.477 15.005,13.458 14.996,13.440 C14.967,13.381 14.952,13.317 14.934,13.251 C14.917,13.185 14.899,13.123 14.895,13.056 C14.894,13.036 14.884,13.020 14.884,13.000 L14.884,7.000 C14.884,4.243 12.655,2.000 9.916,2.000 C7.179,2.000 4.952,4.243 4.952,7.000 L4.952,13.000 C4.952,13.020 4.942,13.037 4.940,13.056 C4.937,13.122 4.919,13.185 4.902,13.250 C4.884,13.316 4.869,13.380 4.839,13.440 C4.831,13.458 4.831,13.477 4.822,13.494 L2.276,18.000 L17.561,18.000 L15.014,13.494 ZM6.938,8.000 C6.938,7.448 7.383,7.000 7.931,7.000 L11.904,7.000 C12.286,7.000 12.634,7.221 12.799,7.567 C12.965,7.913 12.918,8.324 12.680,8.625 L9.998,12.000 L11.904,12.000 C12.453,12.000 12.897,12.448 12.897,13.000 C12.897,13.552 12.453,14.000 11.904,14.000 L7.931,14.000 C7.550,14.000 7.201,13.779 7.036,13.433 C6.871,13.086 6.917,12.676 7.156,12.375 L9.838,9.000 L7.931,9.000 C7.383,9.000 6.938,8.552 6.938,8.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconNotificationPaused.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
